import React from 'react';
import "../styles/Services.css";
import ServiceItem from '../components/ServiceItem';
import { useTranslation } from 'react-i18next';
import { getServiceList } from '../helpers/serviceList';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Services = () => {
  const { t } = useTranslation();
  const serviceList = getServiceList(t);
  const location = useLocation();

useEffect(() => {
  if (location.hash) {
    const element = document.getElementById(location.hash.replace("#", ""));
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
}, [location]);

  return (
    <div className="Service">
      <h1 className="serviceTittle">{t('services.title')}</h1>
      <div className="serviceList">
        {serviceList.map((serviceItem, key) => (
          <ServiceItem
            key={key}
            id={`service-${key}`}
            image={serviceItem.image}
            name={serviceItem.name}
            aciklama={serviceItem.aciklama}
          />
        ))}
      </div>
    </div>
  );
};

export default Services;